/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Diet_Dairy_FreeInputs */

const en_diet_dairy_free = /** @type {(inputs: Diet_Dairy_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dairy-free`)
};

const de_diet_dairy_free = /** @type {(inputs: Diet_Dairy_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laktosefrei`)
};

/**
* | output |
* | --- |
* | "Dairy-free" |
*
* @param {Diet_Dairy_FreeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const diet_dairy_free = /** @type {((inputs?: Diet_Dairy_FreeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Diet_Dairy_FreeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_diet_dairy_free(inputs)
	return en_diet_dairy_free(inputs)
});